import { useMatches } from "react-router";
import type { RootLoaderType } from "~/root";

export const useEnv = () => {
  const matches = useMatches();

  const data = (matches.find((route) => {
    return route.id === "root";
  })?.data || {}) as RootLoaderType;

  return data.ENV || {};
};
